var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('b-header'),_vm._v(" "),_c('b-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce17d18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 